<template>
  <div id="crew-profile" class="h-full">

    <div class="flex justify-between items-center ml-2 py-2">
      <div class="aisea-text-18-600-dark-gray">船員基本情報</div>
      <div class="flex items-centers">
        <div>
          <vs-tooltip text="編集" position="bottom">
            <feather-icon
              icon="Edit2Icon"
              svg-classes="h-4 w-4 m-4"
              class="crew-list-hover-icon"
              @click.stop="showCrewSidebarForEdit()"
            />
          </vs-tooltip>
        </div>
        <div class="pl-2">
          <vs-tooltip text="削除" position="bottom">
            <feather-icon
              icon="Trash2Icon"
              svg-classes="h-4 w-4 m-4"
              class="crew-list-hover-icon"
              @click.stop="showDeletePrompt = true"
            />
          </vs-tooltip>
        </div>
        <div v-if="!hasEnterpriseCrewAccount" class="pl-4">
          <vs-button
            v-if="!isRetirement"
            type="border"
            icon="add"
            :color="AISEA_COLOR.BLUE"
            style="height: 2.7rem;"
            @click.stop="showCrewSidebarforCreateAccount()"
            :disabled="!this.crew.email_address"
            >アプリアカウント発行</vs-button
          >
        </div>
        <div v-else class="pl-4">
          <vs-button
            v-if="!isRetirement"
            type="border"
            icon="lock_reset"
            :color="AISEA_COLOR.BLUE"
            style="height: 2.7rem;"
            @click.stop="showCrewSidebarforEditPass()"
          >
            パスワード変更
          </vs-button>
        </div>
        <div v-if="isRetirement" class="pl-4">
          <vs-button
            type="border"
            :color="AISEA_COLOR.BLUE"
            style="height: 2.7rem;"
            @click.stop="rejoinCrew()"
          >
            <div class="flex items-center">
              <img :src="rejoinIcon" style="width: 14px; height: 14px; margin-bottom: 2px;" />
              <span class="pl-2">復職</span>
            </div>
          </vs-button>
        </div>
        <div v-else class="pl-4">
          <vs-button
            type="border"
            :color="AISEA_COLOR.BLUE"
            style="height: 2.7rem;"
            @click.stop="retirementCrew()"
          >
            <span class="material-icons-outlined mr-2" style="font-size: 14px; vertical-align: -10%;">person_remove</span>
            退職
          </vs-button>
        </div>
      </div>
    </div>
    <vs-divider class="m-0 mb-2" />

    <div class="scroll-area">
      <div class="p-6">
        <div class="flex">
          <div class="flex items-center">
            <!-- アイコン -->
            <span class="mr-6 h-32">
              <vs-avatar
                :src="avatar"
                class="flex-shrink-0 mr-2 crew-large-avatar cursor-default"
                size="100px"
                style="background-color: #b3e5fc"
              />
            </span>

            <!-- 名前 -->
            <div class="mr-6">
              <div class="aisea-text-12-400-gray">{{ crewNameKana }}</div>
              <div class="aisea-text-28-400-black">
                {{ crewName }}
              </div>
              <!-- 退職済バッジ -->
              <div style="height: 24px;" >
                <span v-if="isRetirement" class="retirement-badge">退職済</span>
              </div>
            </div>
            <!-- アカウント種別 -->
            <vs-tooltip :text="accountTooltipText" position="top">
              <div class="flex items-center">
                <img :src="badgeSrc" />
                <span class="aisea-text-14-400-dark-gray ml-2">{{ accountTooltipText }}</span>
              </div>
            </vs-tooltip>
          </div>
        </div>

        <!-- 情報 -->
        <div class="mt-8 text-sm">
          <vs-row>
            <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >生年月日</vs-col>
            <vs-col vs-w="9" class="aisea-text-16-400-black">{{ crewBirthDate }}</vs-col>
          </vs-row>
          <vs-divider />
          <vs-row>
            <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >電話番号</vs-col>
            <vs-col vs-w="9" class="aisea-text-16-400-black">{{ crewPhoneNumber }}</vs-col>
          </vs-row>
          <vs-divider />
          <vs-row>
            <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >メールアドレス(ユーザーID)</vs-col>
            <vs-col vs-w="9" class="aisea-text-16-400-black">{{ crewEmailAdress }}</vs-col>
          </vs-row>
          <vs-divider />
          <vs-row>
            <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >社員番号</vs-col>
            <vs-col vs-w="9" class="aisea-text-16-400-black">{{ crewEmployeeNumber }}</vs-col>
          </vs-row>
          <vs-divider />
          <vs-row>
            <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >雇用形態</vs-col>
            <vs-col vs-w="9" class="aisea-text-16-400-black">{{ crewEmploymentStatus }}</vs-col>
          </vs-row>
          <vs-divider />
          <vs-row>
            <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >所属企業</vs-col>
            <vs-col vs-w="9" class="aisea-text-16-400-black">{{ crewAffiliatedCompany }}</vs-col>
          </vs-row>
          <vs-divider />
          <vs-row>
            <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >組合員該当</vs-col>
            <vs-col vs-w="9" class="aisea-text-16-400-black">{{ crewUnionMember }}</vs-col>
          </vs-row>
        </div>
      </div>
    </div>

    <vs-prompt
      title="復職設定"
      type="alert"
      :color="AISEA_COLOR.BLUE"
      accept-text="実行"
      cancel-text="キャンセル"
      :active.sync="showRejoinPrompt"
      @accept="onRejoin"
      @cancel="onRejoinCancel"
      class="crew-delete-confirm"
    >
      <div class="crew-delete-confirm-body flex-direction--column" >
        <div class="my-2">退職者設定を解除しますか？</div>
        <div class="mb-2">・ 労務ダッシュボードに情報が表示されます。</div>
      </div>
    </vs-prompt>

    <vs-prompt
      title="船員アカウント削除"
      type="alert"
      :color="AISEA_COLOR.BLUE"
      accept-text="実行"
      cancel-text="キャンセル"
      :active.sync="showDeletePrompt"
      @accept="onDelete"
      @cancel="onDeleteCancel"
      class="crew-delete-confirm"
    >
      <div class="crew-delete-confirm-body" >
        {{ crew.name }}のアカウントを削除しますか？<br />
        削除したデータは戻せません。
      </div>
    </vs-prompt>


  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import { ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("crewAccount");
import moment from "moment";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewApi = AiseaApiFactory.get("enterpriseCrew");

export default {
  mixins: [ColorMixin],
  props: {
    activeSidebarCrew: Boolean,
    activeTab: Number,
  },
  data () {
    return {
      activeCrewSidebar: false,
      avatar: null,
      crewProfileParam: null,
      sidebarItem: null,
      sidebarItemEnum: {
        editProfile: 0,
        editAccount: 1,
        setPassword: 2,
        retirement: 3,
        rejoin: 4,
      },
      showDeletePrompt: false,
      showRejoinPrompt: false,
      createAccountStartFlg: false,
      createAccountCompletedFlg: false,
    }
  },
  computed: {
    ...mapState({
      crew: state => state.crewAccount,
    }),
    sidebarStatus: {
      get () { return this.activeSidebarCrew; },
      set (val) { this.$emit('update:activeSidebarCrew', val) }
    },
    hasEnterpriseCrewAccount () {
      return this.crew.enterprise_crew_account
    },
    isRetirement () {
      return this.crew.retirement_date &&  this.crew.retirement_date < moment().local().startOf('day').format('YYYY-MM-DD');
    },
    accountTooltipText () {
      return this.hasEnterpriseCrewAccount ? "アカウント発行済" : "アプリアカウント未発行";
    },
    rejoinIcon () {
      return require("@/assets/images/crew-management/person_return.svg")
    },
    crewName () { return this.crew.name ? this.crew.name : "-" },
    crewNameKana () { return this.crew.name_kana ? this.crew.name_kana : "-" },
    crewBirthDate () { return this.crew.birth_date ? this.crew.birth_date.replace(/-/g, '/') : "-" },
    crewPhoneNumber () { return this.crew.phone_number ? this.crew.phone_number : "-" },
    crewEmailAdress () { return this.crew.email_address ? this.crew.email_address : "-" },
    crewEmployeeNumber () { return this.crew.employee_number ? this.crew.employee_number : "-" },
    crewEmploymentStatus () { return this.crew.employment_status ? this.crew.employment_status : "-" },
    crewAffiliatedCompany () { return this.crew.affiliated_company ? this.crew.affiliated_company : "-" },
    crewUnionMember () { return this.crew.union_member || "-" },
    badgeSrc () {
      const filename = this.hasEnterpriseCrewAccount ? "issued-account" : "unissued-account";
      return require(`@/assets/images/crew-management/badge/${filename}.svg`)
    },
  },
  methods: {
    ...mapActions(["setCrewAccount"]),
    isSelectedItem (item) {
      return item === this.sidebarItem;
    },

    async setAvatar () {
      this.avatar = null;
      if (!this.crew.picture) return;
      const thumbnailPath = this.crew.picture.thumbnail_path;

      if (!thumbnailPath) return;

      await storage
        .child(thumbnailPath)
        .getDownloadURL()
        .then(response => {
          this.avatar = response;
        });
    },
    showCrewSidebarforCreateAccount () {
      this.crewProfileParam = this.crew;
      this.sidebarStatus = true;
      this.sidebarItem = this.sidebarItemEnum.editAccount;
      this.$emit('setDialogTitle', '労務管理アプリアカウント発行');
      this.createAccountStartFlg = true;
    },
    showCrewSidebarforEditPass () {
      this.crewProfileParam = this.crew;
      this.sidebarStatus = true;
      this.sidebarItem = this.sidebarItemEnum.editAccount;
      this.$emit('setDialogTitle', '労務管理アプリパスワード変更');
    },

    showCrewSidebarForEdit () {
      this.crewProfileParam = this.crew;
      this.sidebarStatus = true;
      this.sidebarItem = this.sidebarItemEnum.editProfile;
      this.$emit('setDialogTitle', '船員基本情報編集');
    },

    retirementCrew () {
      this.crewProfileParam = this.crew;
      this.sidebarStatus = true;
      this.sidebarItem = this.sidebarItemEnum.retirement;
      this.$emit('setDialogTitle', '退職処理');
    },

    async onDelete() {
      this.showDeletePrompt = true;
      const name = this.crew.name;
      await enterpriseCrewApi.delete(this.crew.id);
      this.$vs.notify({
        title: `船員基本情報削除`,
        text: `${name}の登録内容を削除しました`,
        color: "success",
        icon: "done"
      });
      this.$nextTick(() => {
        this.showDeletePrompt = false;
      });
    },
    onDeleteCancel() {
      this.showDeletePrompt = true;
      this.$nextTick(() => {
        this.showDeletePrompt = false;
      });
    },

    rejoinCrew () {
      this.showRejoinPrompt = true;
    },
    async onRejoin() {
      this.showRejoinPrompt = true;

      let payload = {
        birth_date: this.crew.birth_date,
        email_address: this.crew.email_address,
        name: this.crew.name,
        name_kana: this.crew.name_kana,
        phone_number: this.crew.phone_number,
        affiliated_company: this.crew.affiliated_company,
        employee_number: this.crew.employee_number,
        employment_status: this.crew.employment_status,
        union_member: this.crew.union_member,
        picture: this.crew.picture ? this.crew.picture.id : null,
        retirement_date: null,
      };

      const res = await enterpriseCrewApi.update(this.crew.id, payload)

      if (!res || !res.status) {
        this.$vs.notify({
          title: `船員基本情報編集`,
          text: `${this.crew.name}の復職設定に失敗しました。時間を空けて再度試みてください。`,
          color: "danger",
          icon: "done"
        });
        return;
      }

      this.$vs.notify({
        title: `船員基本情報編集`,
        text: `${this.crew.name}の復職設定が完了しました。`,
        color: "success",
        icon: "done"
      });
      this.setCrewAccount(this.crew.id);
      this.$emit('checkAlert');

      this.$nextTick(() => {
        this.showRejoinPrompt = false;
      });
    },
    onRejoinCancel() {
      this.showRejoinPrompt = true;
      this.$nextTick(() => {
        this.showRejoinPrompt = false;
      });
    },

    reloadList(val) {
      this.setCrewAccount(this.crew.id);
      if ( val === 'createAccountCompleted' ) {
        this.createAccountCompletedFlg = true;
      }
    },

  },
  watch: {
    crew () {
      this.setAvatar();
    },
    activeSidebarCrew (val) {
      if ( val === false ) {
        if ( this.createAccountStartFlg === true && this.createAccountCompletedFlg === true ) {
          this.$vs.notify({
            title: "船員基本情報設定",
            text: `${this.crewName}の労務管理アプリアカウントを設定しました。`,
            icon: "done",
            color: "success"
          });
        }
        this.createAccountStartFlg     = false;
        this.createAccountCompletedFlg = false;
      }
    }
  },
  created () {
    this.setAvatar()
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#crew-profile {
  font-family: $aisea-font-family;

  .retirement-badge {

    font-size:14px;
    color: $aisea-dark-gray;
    background-color: $aisea-white;
    border-radius: 4px;
    padding: 4px 6px;

  }

  .crew-list-hover-icon {
    border-radius: 4px;
    color: $aisea-gray;
    &:hover {
      background-color: $aisea-light-gray;
    }
  }

  .scroll-area {
    overflow-y: auto;
    height: calc(100% - 20px);
  }

  .crew-large-avatar {
    span {
      font-size: 60px;
    }
  }

}
.crew-delete-confirm {

  .vs-dialog {
    min-width: 560px;

    .vs-dialog-header {
      color: $aisea-black !important;
    }

    .dialog-title {
      color: $aisea-black !important;
      font-family: $aisea-font-family !important;
      font-size: 18px;
    }

    .crew-delete-confirm-body {
      font-family: $aisea-font-family !important;
      font-size: 16px;
    }

    .vs-dialog-cancel {
      background-color: rgba(244, 244, 244, 0.0) !important;
      transform: none !important;
      box-shadow: none !important;
    }
  }
}
</style>



